import { Dimensions, Quantity } from '@elderbyte/ngx-starter'

export class MaterialComponent {
  /**
   * The material number
   */
  public materialId: string

  /**
   * The material group
   */
  public materialTypeId: string

  /**
   * The material group
   */
  public materialGroupId: string

  /**
   * The component description
   */
  public searchTerm: string

  /**
   * The material which has been chosen but has been replaced with an other material
   */
  public replacedMaterial: string

  /**
   * The quantity of this material item.
   */
  public quantity: number

  /**
   * A factor to calculate the sales-quantity from the quantity.
   */
  public toSales: Quantity

  /**
   * A factor to calculate the sales-price-quantity from the quantity.
   */
  public toSalesPrice: Quantity

  /**
   * A factor to calculate the stock-quantity from the quantity.
   */
  public toStock: Quantity

  /**
   * A factor to calculate the purchase-quantity from the quantity.
   */
  public toPurchase: Quantity

  /**
   * A factor to calculate the weight from the quantity.
   * Null means that this product has no weight.
   */
  public toWeight: Quantity

  /**
   * The dimensions of a single unit (item) of this material
   * Null means that this product has no dimensions.
   */
  public unitDimensions: Dimensions

  public static salesQuantity(product: MaterialComponent): Quantity | null {
    if (product?.toSales) {
      return Quantity.from(product.toSales.unit, product.toSales.value * product.quantity)
    } else {
      return null
    }
  }

  public static salesUnitWeight(product: MaterialComponent): Quantity | null {
    if (product?.toWeight) {
      return Quantity.from(product.toWeight.unit, product.toWeight.value / product.toSales.value)
    } else {
      return null
    }
  }

  public static getWeight(product: MaterialComponent): Quantity | null {
    if (product?.toWeight) {
      return Quantity.from(product.toWeight.unit, product.toWeight.value * product.quantity)
    } else {
      return null
    }
  }

  public static equals(a: MaterialComponent, b: MaterialComponent): boolean {
    if (a === b) {
      return true
    }
    if (!b) {
      return false
    }
    return a.materialId === b.materialId && a.quantity === b.quantity
  }
}
